<template>
  <div class="personalwrap">
    <Header></Header>
    <div class="breadbox">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <div class="clearfix bread">
          <img src="~img/direction.png" alt="" />
          <el-breadcrumb-item
            v-for="item in breadlist"
            :key="item.path"
            :to="{ path: item.path }"
            >{{ item.meta.name }}</el-breadcrumb-item
          >
        </div>
      </el-breadcrumb>
    </div>
    <div class="contianer clearfix">
      <!-- <div class="con-left fl">
        <div class="peopleInfo">
          <img src="https://b.heiyanimg.com/people/19921308.jpg@!us?1" alt="" />
          <p class="name">小可爱</p>
          <div>
            <router-link to="/news" class="useroption">提醒</router-link>
            <router-link to="/option" class="useroption">设置</router-link>
            <router-link to="javaScript:" class="useroption">退出</router-link>
          </div>
        </div>
        <ul class="person-center">
          <li v-for="item in navlist" :key="item.name">
            <router-link :to="item.url">{{ item.name }}</router-link>
          </li>
        </ul>
      </div> -->
      <div class="con-right fr">
        <router-view></router-view>
      </div>
      <sidebar :isSet="true" :navlist="navlist" :link="islink"></sidebar>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
export default {
  data() {
    return {
      navlist: [],
      breadlist: [],
      islink: true
    };
  },
  created() {
    this.getBreadcrumb();
    if (this.isShowA) {
      this.navlist = [
        { url: "/personal/center", name: "个人中心" },
        { url: "/personal/myAccount", name: "账户充值" },
        { url: "/personal/collect", name: "我的收藏" },
        { url: "/personal/message", name: "消息通知" }
      ];
    } else {
      this.navlist = [
        { url: "/personal/center", name: "个人中心" },
        { url: "/personal/myAccount", name: "账户充值" },
        { url: "/personal/collect", name: "我的收藏" },
        { url: "/personal/message", name: "消息通知" }
      ];
    }
  },
  watch: {
    $route() {
      /* 面包屑 */
      this.getBreadcrumb();
    }
  },
  methods: {
    getBreadcrumb() {
      let matched = this.$route.matched.filter(item => item.name);
      this.breadlist = matched;
      //console.log(this.breadlist);
    }
  }
};
</script>
<style lang="stylus" scoped>
.con-left
    height 100%
.con-right
    min-height 75vh
</style>
